import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Teleport as _Teleport, Fragment as _Fragment } from "vue";
import { ref, watchEffect, useSlots, computed, cloneVNode } from 'vue';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/vue'; // eslint-disable-line

export default {
  __name: 's-floating',
  props: {
    message: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'top'
    },
    // top, bottom, left, right | top-start, top-end ...
    offset: {
      type: Number,
      default: 4
    },
    flip: Object
  },
  emits: 'update:position',
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const reference = ref(null);
    const floating = ref(null);
    const slots = useSlots();
    const clonedSlot = computed(() => {
      const content = slots.default?.();
      if (!content || content.length === 0) return null;
      const element = content[0].key === '_default' ? content[0].children[0] : content[0];
      return cloneVNode(element, {
        ref: reference
      });
    });
    const computedFlip = computed(() => {
      const flip = props.flip ?? {};
      if (!('fallbackPlacements' in flip)) {
        flip.fallbackPlacements = {
          top: ['top', 'bottom', 'left', 'right'],
          bottom: ['bottom', 'top', 'left', 'right'],
          left: ['left', 'right', 'bottom', 'top'],
          right: ['right', 'left', 'bottom', 'top']
        }[props.position];
      }
      return flip;
    });
    function capturePlacementMiddleware() {
      return {
        name: 'capturePlacement',
        fn({
          placement
        }) {
          emits('update:position', placement);
          return {};
        }
      };
    } // eslint-disable-line

    const {
      floatingStyles,
      update
    } = useFloating(reference, floating, {
      placement: props.position,
      middleware: [offset(props.offset), flip(computedFlip.value), shift({
        crossAxis: true,
        padding: 4
      }), capturePlacementMiddleware()],
      whileElementsMounted: autoUpdate
    });

    // Opcional: actualizar cuando se monta o cambian elementos
    watchEffect(() => {
      if (reference.value && floating.value) {
        update();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [clonedSlot.value ? (_openBlock(), _createBlock(_resolveDynamicComponent(clonedSlot.value), {
        key: 0
      })) : _createCommentVNode("", true), clonedSlot.value ? (_openBlock(), _createBlock(_Teleport, {
        key: 1,
        to: "body"
      }, [__props.open ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "floating",
        ref: floating,
        class: "fixed z-50",
        style: _normalizeStyle(_unref(floatingStyles))
      }, [_renderSlot(_ctx.$slots, "floating")], 4)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
    };
  }
};